(function () {
  'use strict';

  var scheduled = false;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isShopifyProductImage(value) {
    return /cdn\.shopify\.com|shopifycdn\.com|\/cdn\/shop\//i.test(value || '');
  }

  function findWishlistRoot() {
    var controls = document.querySelectorAll('button, a, [role="button"], h1, h2, h3, h4, [role="heading"]');
    var marker = null;

    for (var i = 0; i < controls.length; i += 1) {
      var label = normalizeText(controls[i].textContent);
      if (label === 'remove all from wishlist' || label === 'my wishlist') {
        marker = controls[i];
        break;
      }
    }

    if (!marker) return null;

    var node = marker;
    while (node && node !== document.body) {
      var text = normalizeText(node.textContent);
      if (
        text.indexOf('my wishlist') !== -1 &&
        text.indexOf('add all to cart') !== -1 &&
        text.indexOf('remove all from wishlist') !== -1
      ) {
        return node;
      }
      node = node.parentElement;
    }

    return null;
  }

  function fitWishlistImages(root) {
    if (!root) return;

    root.querySelectorAll('img').forEach(function (img) {
      var src = img.currentSrc || img.src || '';
      var rect = img.getBoundingClientRect();

      if (isShopifyProductImage(src) && rect.width > 80 && rect.height > 80) {
        var computed = window.getComputedStyle(img);
        if (computed.objectFit !== 'contain') {
          img.style.setProperty('object-fit', 'contain', 'important');
          img.style.setProperty('object-position', 'center center', 'important');
        }
      }
    });

    root.querySelectorAll('*').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.width <= 80 || rect.height <= 80) return;

      var computed = window.getComputedStyle(el);
      var backgroundImage = computed.backgroundImage || '';

      if (backgroundImage !== 'none' && isShopifyProductImage(backgroundImage)) {
        if (computed.backgroundSize !== 'contain') {
          el.style.setProperty('background-size', 'contain', 'important');
          el.style.setProperty('background-position', 'center center', 'important');
          el.style.setProperty('background-repeat', 'no-repeat', 'important');
        }
      }
    });
  }

  function run() {
    scheduled = false;
    fitWishlistImages(findWishlistRoot());
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  function start() {
    schedule();

    var observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'style', 'class']
    });

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('a[href="#hero-wishlist"], .wishlist-hero-header-icon') : null;
      if (!target) return;
      window.setTimeout(schedule, 0);
      window.setTimeout(schedule, 250);
      window.setTimeout(schedule, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
